import React from 'react';
import { TableRow } from './TableRow';
import { NoRows } from '../../../layout/Table/NoRows';

function TableBody(props) {
  const renderRows = () => {
    const { emailCampaigns } = props;

    if (! Array.isArray(emailCampaigns) || emailCampaigns.length === 0) {
      return <NoRows colSpan="8"/>;
    }

    return emailCampaigns.map(renderRow);
  };

  const renderRow = (emailCampaign, index) => {
    const { actionCallback } = props;

    return (
      <TableRow
        shouldRenderFields={ props.shouldRenderFields }
        key={ index }
        emailCampaign={ emailCampaign }
        actionCallback={ actionCallback }
        index={ index }
      />
    )
  }
    return (
      <tbody>
      { renderRows() }
      </tbody>
    )
}

export { TableBody };
